module.exports = __webpack_public_path__ + "img/multi-store-data-combination.613b0d85.svg";